// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import { uploadDocumentSuccess, uploadDocumentFailure } from './actions';
import { UPLOAD_DOCUMENT_REQUEST} from './actionTypes';
import { uploadDocument } from '../../helpers/backend_helper';
import { fetchProductsRequest } from '../actions';
import { reduxSerializedError } from '../../utils/utils';

function* uploadDocumentSaga({payload}) {
  const { document, entity, config } = payload;
  try {
    const response = yield call(uploadDocument, document, entity, config);

    // Store the mapping in localStorage if response exists and has items
    yield put(uploadDocumentSuccess(response));
    yield put(fetchProductsRequest());
  } catch (error) {
    yield put(uploadDocumentFailure(reduxSerializedError(error)));
  }
}

export default function* rootSaga() {
  yield takeEvery(UPLOAD_DOCUMENT_REQUEST, uploadDocumentSaga);
}
